<template>
  <div>
    <div class="pl-10 d-flex flex-column selected-questions-header bg-gray">
      <h3 style="margin-top: 14px;">Ihre Fragenauswahl</h3>
      <p class="text-gray text-subtitle">Prüfen Sie die Fragen und senden Sie die Umfrage ab.</p>
    </div>
    <div class="bg-gray d-flex justify-center">
      <v-card flat style="height:calc(100vh - 200px); overflow-y: scroll; width: 90vw; border-radius: 10px;">
        <v-card-title class="table-header">
          <v-row align="center">
          </v-row>
        </v-card-title>
        <v-main style="margin:5px; padding: 20px 4vw;">
          <v-expansion-panels flat focusable>
            <v-expansion-panel
                v-for="page in schema.pages"
                :key="page.name"
                class="border-bottom"
            >
              <v-expansion-panel-header class="text-semibold text-gray"  style="align-items: start;
                     justify-content: flex-start">
                <span
                    :class="'element-title '+getElementIcon(page.name)"/><span class="ml-4">{{page.title}}</span>
                <v-spacer/>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-list-item v-for="question in page.questions" :key="question.name">
<!--                          <v-list-item-icon>
                           <v-icon color="primary">mdi-help-network-outline</v-icon>
                         </v-list-item-icon> -->
                  <v-list-item-content>
                    <v-row>
                      <v-col cols="2">
                        <v-chip small label outlined color="lightblue" class="overview-question-label">
                          Frage {{page.questions.indexOf(question) +1}}
                        </v-chip>
                      </v-col>
                      <v-col cols="10">
                        <p class="overview-question-text">
                          {{ getQuestionText(question) }}
                        </p>
                      </v-col>
                    </v-row>
<!--                    <v-list-item-title>{{getQuestionText(question)}}</v-list-item-title>-->
                  </v-list-item-content>
                </v-list-item>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-main>
      </v-card>
    </div>
    <div class="mt-4 bg-gray py-6 action-btn">
      <v-spacer/>
      <div class="float-right" style="padding-right: 3vw;">
        <v-btn color="gray" text class="bottomButton" @click="cancel()">Abbrechen</v-btn>
        <v-btn color="primary" elevation="0" class="bottomButton" @click="submitSurvey()">Umfrage erstellen</v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import PXSurvey from "@/components/common/PXSurvey.vue"
import pxSurveyService from "@/pages/PxQuestionSurvey/PXSurveyPage/px-survey-service"
export default {
  data: () => ({
    schema: {},
    surveyTitle: ""
  }),
  components: {
    PXSurvey
  },
  watch: {
  },
  mounted() {
      this.schema = this.$route.params.schema;
      this.schema.pages = this.schema.pages.filter(page => page.questions != null);
      this.surveyTitle = this.$route.params.surveyTitle;
      this.selectedModule = 4;
  },
  methods: {
    submitSurvey(){
        pxSurveyService.savePXSurvey(this.schema, this.selectedModule).then(() => 
          this.$router.push('/surveys')
        )
      },
      cancel(){
        this.$router.go(-1)
      },
      getQuestionText(question){
        if(question.rows != null) return question.rows[0].text;
      },
      getElementIcon(id){
        if(id.includes("Pool")){
          return "bpmn-icon-participant";
        }else if(id.includes("Lane")){
          return "bpmn-icon-lane-divide-two";
        }else if(id.includes("Activity")){
          return "bpmn-icon-call-activity";
        }else if(id.includes("Gateway")){
          return "bpmn-icon-gateway-none";
        }else if(id.includes("Flow")){
          return "bpmn-icon-connection";
        }else if(id.includes("Event")){
          return "bpmn-icon-start-event-none";
        }else if(id.includes("DataObject")){
          return "bpmn-icon-data-object";
        }else if(id.includes("DataStore")){
          return "bpmn-icon-data-store";
        } 
      }
  },
};
</script>
<style scoped>
.selected-questions-header {
  height: 100px;
  padding-top: 20px;
}
.frame{
    border: 1px solid lightgray;
    margin:5px;
}
.row{
    margin:5px;
}
.filter{
    width:10%;
    float:right;
    margin-right: 10px;
}
.table-header{
    padding:0 !important
}
.bottomButton{
    margin:0px 10px;
}
.action-btn {
  width: 100%;
  height: 100px;
  position: absolute;
  bottom: 0;
  padding-bottom: 20px;
}

.element-title {
  flex: unset !important;
}
:deep .v-list-item__content {
  padding: 0;
}
</style>